import { render, staticRenderFns } from "./Multichain.vue?vue&type=template&id=53acee06&"
import script from "./Multichain.vue?vue&type=script&lang=js&"
export * from "./Multichain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports